import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Justifications } from 'contracts/Justifications';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_JUSTIFICATION_',
  }
);

export interface FetchJustificationState {
  data: Justifications | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchJustificationRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Justifications;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchJustificationState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchJustificationState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchJustificationState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchJustificationState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchJustificationState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchJustification = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchJustificationTypes = Types;
export const FetchJustificationActions = Creators;
